import React, {Component} from 'react'
import ArtistService from "../../../../services/ArtistService";
import Spinner from "../../../../components/Spinnner/Spinner";
import ArtistImage from "../../../../components/ArtistItem/ArtistImage";
import Pagination from "../../../../components/DashboardComponents/Pagination";
import SearchBar from "../../../../components/SearchBar/SearchBar";
import FontAwesomeComponent, {RemoveFontAwesome, SortIcon} from "../../../../components/FontAwesomeComponent";
import classes from '../Artists/styles/artist.module.css'
import queryString from 'query-string';
import {Link, NavLink} from "react-router-dom";
import {ModalView} from "../../../../components/BootstrapModal";
import * as actions from '../../../../layouts/RootLayout/rootLayout.reducer'
import {connect} from 'react-redux'

import {
    DateFormatCMSComponent,
    DateTimePicker,
    NepaliCurrency,
    ResetCMSButton,
    SearchCMSComponent, SelectCMSComponent,
    SubmitCMSButton
} from "../../../../components/CMSFormComponents";
import AudioProductionOrderService from "../../../../services/AudioProductionOrderService";
import moment from 'moment'
import NumberFormat from 'react-number-format';
import UserAdminService from "../../../../services/UserAdminService";
import AudioProductionService from "../../../../services/AudioProductionService";
import ProductionOrderStatusService from "../../../../services/ProductionOrderStatusService";

class AudioProductionOrders extends Component{

    state = {
        entities: [],
        page: 0,
        sortField: 'id',
        sortOrder: 'asc',
        totalPages: 0,
        noEntity: false,
        deleteEntity: {id: -1, username: ''},
        // USERNAME
        usernameInputValue: '',
        username: '',
        // AUDIO-PRODUCTION-TYPE
        audioProductionTypeInputValue: '',
        audioProductionType: '',
        // DATE
        startDateInputValue: null,
        startDate: null,
        endDateInputValue: null,
        endDate: null,
        // STATUS
        productionStatus: '',
        productionStatusInputValue: '',
        productionOrderStatusList: []
    }

    componentDidMount() {
        let params = queryString.parse(this.props.location.search);
        if(JSON.stringify(params) !== '{}'){
            let tempState = {};
            if(params.username){
                tempState.username = params.username;
            }
            if(params.audioProductionType){
                tempState.audioProductionType = params.audioProductionType;
            }
            if(params.sort){
                const values = params.sort.split(",");
                tempState.sortField = values[0];
                tempState.sortOrder = values[1];
            }
            if(params.page){
                tempState.page = +params.page;
            }
            if(params.startDate){
                tempState.startDate = params.startDate;
            }
            if(params.endDate){
                tempState.endDate = params.endDate;
            }
            if(params.productionStatus){
                tempState.productionStatus = params.productionStatus;
            }
            this.setState(tempState);
            if(tempState.page === 0 ) this.getEntities()
        } else {
            this.getEntities();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevState.page !== this.state.page || prevState.sortField !== this.state.sortField || prevState.sortOrder !== this.state.sortOrder || prevState.username !== this.state.username || prevState.audioProductionType !== this.state.audioProductionType || prevState.startDate !== this.state.startDate || prevState.endDate !== this.state.endDate || prevState.productionStatus !== this.state.productionStatus){
            this.getEntities();
            let url = `${this.props.location.pathname}?page=${this.state.page}&sort=${this.state.sortField},${this.state.sortOrder}`;
            url += this.state.username && this.state.username !== '' ? `&username=${this.state.username}`: '';
            url += this.state.audioProductionType && this.state.audioProductionType !== '' ? `&audioProductionType=${this.state.audioProductionType}`: '';
            url += this.state.startDate && this.state.startDate !== '' ? `&startDate=${this.state.startDate}`: '';
            url += this.state.endDate && this.state.endDate !== '' ? `&endDate=${this.state.endDate}`: '';
            url += this.state.productionStatus && this.state.productionStatus !== '' ? `&productionStatus=${this.state.productionStatus}`: '';
            this.props.history.push(url);
        }
    }

    getEntities = () => {
        this.setState({noEntity: false})
        AudioProductionOrderService.getPagedAudioProductionOrders({page: this.state.page, sortField: this.state.sortField, sortOrder: this.state.sortOrder, username: this.state.username, audioProductionType: this.state.audioProductionType, startDate: this.state.startDate, endDate: this.state.endDate, productionStatus: this.state.productionStatus}).then(
            res => {
                this.setState({entities: [...res.data.content], totalPages: res.data.totalPages, noEntity: res.data.content.length === 0 ? true : false});
            }
        );
        ProductionOrderStatusService.getAllProductionOrderStatus().then(res => this.setState({productionOrderStatusList: ["Select Status", ...res.data]}));
    }

    handlePageClick = ({selected}) => {
        this.setState({page: selected});
    }

    onSearchHandler = (event) => {
        if(event) event.preventDefault();
        this.setState({page: 0, username: this.state.usernameInputValue, audioProductionType: this.state.audioProductionTypeInputValue, startDate: this.state.startDateInputValue, endDate: this.state.endDateInputValue, productionStatus: this.state.productionStatusInputValue});
    }

    onResetSearchHandler = (event) => {
        if(event) event.preventDefault();
        this.setState({page: 0, sortField: 'id', sortOrder: 'asc', usernameInputValue: '', username: '', audioProductionTypeInputValue: '', audioProductionType: '', startDateInputValue: null, startDate: null, endDateInputValue: null, endDate: null, productionStatus: ''});
    }

    sortByHandler = (field) => {
        if(this.state.sortField === field){
            this.setState({sortOrder: this.state.sortOrder === 'asc' ? 'desc' : 'asc', page : 0});
        } else {
            this.setState({sortField: field, sortOrder: 'asc', page: 0});
        }
    }

    deleteEntity = (id) => {
        AudioProductionOrderService.deleteAudioProductionOrder(id).then(
            (res) => {
                this.props.sucessToast("Successfully Deleted Production Order: " + res.data.id)
                this.getEntities();
            }
        ).catch(() => this.props.errorToast("Something went wrong"))
    }

    TopToolbar = () => {
        return (<>
                <div style={{display: "flex", justifyContent: "center", flexWrap: "wrap", clear: "both"}}>
                    <SearchCMSComponent title="Username" searchText={this.state.usernameInputValue} fieldName={"username"} setSearchText={(value) => this.setState({usernameInputValue: value})} entityServiceSearchCall={UserAdminService.searchForUsersByUsername}/>
                    <SearchCMSComponent title="Audio Production Type" searchText={this.state.audioProductionTypeInputValue} fieldName={"audioProductionType"} setSearchText={(value) => this.setState({audioProductionTypeInputValue: value})} entityServiceSearchCall={AudioProductionService.searchForAudioProductionsByType}/>
                    <DateTimePicker label="Start Date" selected={this.state.startDateInputValue} onChange={date => this.setState({startDateInputValue: date})}/>
                    <DateTimePicker label="End Date" selected={this.state.endDateInputValue} onChange={date => this.setState({endDateInputValue: date})}/>
                    <SelectCMSComponent label="Status" onChange={data => data != "Select Status" ? this.setState({productionStatusInputValue: data}) : this.setState({productionStatusInputValue: ''})} list={this.state.productionOrderStatusList}/>
                </div>
                <div style={{display: "flex", justifyContent: "center", marginBottom: "10px"}}>
                    <SubmitCMSButton onSearch={this.onSearchHandler}/>
                    <ResetCMSButton onResetSearch={this.onResetSearchHandler}/>
                </div>
            </>
        );
    }

    render() {

        if(this.state.entities.length === 0 && this.state.noEntity){
            return (
                <>
                    {this.TopToolbar()}
                    <div className="card" style={{width: "80%", textAlign: "center", margin: "0 auto", maxWidth: "600px"}}>
                        <div className="card-body">
                            <h5 className="card-title">No Such Item Found</h5>
                            <button onClick={this.onResetSearchHandler} className="btn btn-primary">Reset</button>
                        </div>
                    </div>
                </>
            )
        }

        if(this.state.entities.length == 0){
            return (
                <Spinner/>
            );
        }

        return (
            <>
                {this.TopToolbar()}
                <Pagination handlePageClick={this.handlePageClick} totalPages={this.state.totalPages} currentPage={this.state.page}/>
                <table className="table table-hover">
                    <thead>
                    <tr>
                        <th onClick={this.sortByHandler.bind(this, 'id')} className={classes.clickableTableHeader} style={this.state.sortField === 'id' ? {backgroundColor: "#ccc"}: null} scope="col"># <SortIcon/></th>
                        <th onClick={this.sortByHandler.bind(this, 'user.username')} className={classes.clickableTableHeader} style={this.state.sortField === 'user.username' ? {backgroundColor: "#ccc"}: null} scope="col">Username <SortIcon/></th>
                        <th onClick={this.sortByHandler.bind(this, 'audioProduction.audioProductionType')} className={classes.clickableTableHeader} style={this.state.sortField === 'audioProduction.audioProductionType' ? {backgroundColor: "#ccc"}: null} scope="col">Audio Production Type <SortIcon/></th>
                        <th onClick={this.sortByHandler.bind(this, 'orderPrice')} className={classes.clickableTableHeader} style={this.state.sortField === 'orderPrice' ? {backgroundColor: "#ccc"}: null} scope="col">Price <SortIcon/></th>
                        <th onClick={this.sortByHandler.bind(this, 'orderDate')} className={classes.clickableTableHeader} style={this.state.sortField === 'orderDate' ? {backgroundColor: "#ccc"}: null} scope="col">Date <SortIcon/></th>
                        <th onClick={this.sortByHandler.bind(this, 'productionOrderStatus')} className={classes.clickableTableHeader} style={this.state.sortField === 'productionOrderStatus' ? {backgroundColor: "#ccc"}: null} scope="col">Status <SortIcon/></th>
                        <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        this.state.entities.map(entity => {
                            return (
                                <tr key={entity.id}>
                                    <th>{entity.id}</th>
                                    <td>{entity.userName}</td>
                                    <td>{entity.audioProductionType}</td>
                                    <td><NepaliCurrency value={entity.orderPrice}/></td>
                                    <td><DateFormatCMSComponent value={entity.orderDate}/></td>
                                    <td><span className="badge badge-primary">{entity.productionOrderStatus}</span></td>
                                    <td style={{display: "flex", justifyContent: "space-around"}}>
                                        <Link to={`${this.props.match.url}/${entity.id}`}><button className="btn btn-primary">Views</button></Link>
                                        <Link to={`${this.props.match.url}/${entity.id}/edit`}><button className="btn btn-warning">Edit</button></Link>
                                        <button onClick={() => this.setState({deleteEntity: {id: entity.id, username: entity.username}})} className="btn btn-danger" data-toggle="modal" data-target="#customModal">Remove</button>
                                    </td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
                <ModalView title={`Delete Order: ${this.state.deleteEntity.username}`} id={this.state.deleteEntity.id} body={`Are you sure you want to remove Audio Production Order: ${this.state.deleteEntity.id}?`} callback={this.deleteEntity} confirmLabel={<><RemoveFontAwesome/> Delete</>} buttonTheme="btn-danger"/>
            </>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        sucessToast: (message) => dispatch(actions.sucessToast(message)),
        errorToast: (message) => dispatch(actions.errorToast(message))
    }
}

export default connect(null, mapDispatchToProps)(AudioProductionOrders);

